import { Reducer } from 'redux';
import { types } from './session.types';
import { IPublicUserTrackingInfo, ISessionState, IDeviceInfo } from './session';

const initialState: ISessionState = {
  isLoading: false,
  error: null,
  preferredLang: '',
  customerCode: '',
  unsupportedBrowser: false,
  useNativeCamera: false,
  startRecordingUserSession: false,
  publicUserTrackingInfo: null,
  deviceInfo: null,
};

const sessionReducer: Reducer<ISessionState, any> = (state = initialState, action): ISessionState => {
  switch (action.type) {
    case types.SET_PUBLIC_USER_TRACKING_INFO: {
      return { ...state, publicUserTrackingInfo: action.payload as IPublicUserTrackingInfo };
    }
    case types.START_RECORDING_USER_SESSION: {
      return { ...state, startRecordingUserSession: true };
    }
    case types.STORE_CUSTOMER_CODE_SUCCESS: {
      return { ...state, customerCode: action.payload as string };
    }

    case types.STORE_PREFERRED_LANGUAGE_SUCCESS: {
      return { ...state, preferredLang: action.payload as string };
    }

    case types.LOG_OUT_STARTED: {
      return { ...state, isLoading: true };
    }

    case types.LOG_OUT_FAILURE: {
      return { ...state, isLoading: false, error: action.payload as string };
    }

    case types.LOG_OUT_SUCCESS: {
      return initialState;
    }

    case types.STORE_UNSUPPORTED_BROWSER: {
      return {
        ...state,
        unsupportedBrowser: action.payload as boolean
      };
    }

    case types.STORE_USE_NATIVE_CAMERA: {
      return {
        ...state,
        useNativeCamera: action.payload as boolean
      };
    }

    case types.STORE_DEVICE_INFO: {
      return {
        ...state,
        deviceInfo: action.payload as IDeviceInfo
      };
    }

    default: {
      return state;
    }
  }
};

export { sessionReducer };
